import { Helmet } from 'react-helmet';
import ThongkethegioDetail from 'src/components/thongkethegio-detail/ThongkethegioDetail';

import {
  Box,
  Container,
} from '@material-ui/core';

const Thongkethegio = () => (
  <>
    <Helmet>
      <title>Thống kê thẻ (giờ)</title>
    </Helmet>
    <Box
      sx={{
        backgroundColor: 'background.default',
        minHeight: '100%',
        py: 3
      }}
    >
      <Container style={{maxWidth: "100%"}}>
        <Box sx={{ pt: 3 }}>
          <ThongkethegioDetail />
        </Box>
      </Container>
    </Box>
  </>
);

export default Thongkethegio;
